import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '@core/conf/app-constants';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, TranslatePipe]
})
export class ErrorComponent implements OnInit, OnDestroy {
  private error: any;
  private sub: any;
  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.error = params;
      console.log('this.error', this.error);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get appConstants() {
    return AppConstants;
  }
}
